module.exports = __webpack_public_path__ + "img/cross.9aaf0d90.svg";